<div mat-dialog-title>
  <span>{{ 'RENUMBER_ACT.TITLE' | translate }}</span>
  <q9-dialog-close-button></q9-dialog-close-button>
</div>

<mat-dialog-content class="content">
  <q9-info-message type="warn">
    <div>
      <span>* &nbsp;</span>
      <span>{{ 'POPUPS.NOT_UNDOABLE' | translate }}</span>
    </div>
    <div>
      <span>* &nbsp;</span>
      <span>{{ 'POPUPS.SWAP_ACTIVITY_HINT' | translate }}</span>
    </div>
  </q9-info-message>
  <form [formGroup]="form" #formTemplate="ngForm">
    <q9-text-field
      formControlName="number"
      [label]="'RENUMBER_ACT.PLACEHOLDER' | translate"></q9-text-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <q9-secondary-button mat-dialog-close>
    {{ 'SHARE_DIAGRAM.CHANGE_OWNER_CANCEL_BTN' | translate }}
  </q9-secondary-button>
  <q9-primary-button [isLoading]="processing()" (click)="formTemplate.onSubmit($event); onSubmit()">
    {{ 'RENUMBER_ACT.SUBMIT' | translate }}
  </q9-primary-button>
</mat-dialog-actions>
